import { PaginationFilterRequest } from "./core.model";

export interface StoryChapterMedia {
  id: number;
  text: string;
  imageUrl: string;
  voiceUrl: string;
  language: string;
  order: number;
  isIntro: boolean;
  chapterId: number;
}


export interface UpsertStoryChapterMedia {
  id?: number;
  text?: string;
  imageUrl?: string;
  voiceUrl?: string;
  language?: string;
  order?: number;
  isIntro?: boolean;
  chapterId?: number;
}

export class StoryChapterMediaPaginationFilterRequest extends PaginationFilterRequest{  
    chapterId?: number;
    language?: string;
}
